interface PreloadData {
  accessUrl: string
  startup: {
    configId: number
    picture: string
    language: string[]
    state: string
    order: number
  }
  merchant: {
    tenantCode: string
    id: string
    name: string
    siteName: string
    clientSkin: string
    languages: string[]
    currency: string
    timezone: string
    telephoneAreaCode: string
    level: string
    userDomain: string[]
    adminDomain: string[]
    siteStatus: string
    dataSource: string
    kgRetailId: string
  }
  WebUpdateVersionPopUp: string

  jPushConfig: {
    status: string
    baseUrl: string
    appKey: string
  }
  homeBanner: {
    suspendIcon: Array<{
      configId: number
      picture: string
      language: string[]
      hyperlinkType: string
      hyperlink: string
      state: string
      activityId: string
      displayCondition: string
      redDotHint: string
      order: number
    }>
    availableIconUrl: string
    carouselMessage: Array<{
      configId: number
      rotationContent: string
      language: string[]
      state: string
      order: number
    }>
    topDownload: {
      configId: number
      asset: string
      language: string[]
      state: string
      order: number
    }
    bottomDownload: {
      configId: number
      asset: string
      language: string[]
      state: string
      order: number
    }
    bottomText: {
      configId: number
      text: string
      language: string[]
      state: string
      order: number
    }
    bigBanner: Array<{
      configId: number
      picture: string
      language: string[]
      hyperlinkType: string
      hyperlink: string
      state: string
      activityId: string
      order: number
    }>
  }
  smallBanner: Array<{
    configId: number
    picture: string
    language: string[]
    hyperlinkType: string
    hyperlink: string
    state: string
    order: number
  }>
  popupImage: Array<{
    configId: number
    picture: string
    language: string[]
    order: number
    popupType: string
    popupGroup: string
    popupLevelType: string[]
    popupLevel: string[]
    hyperlinkType: string
    hyperlink: string
    state: string
    interval: number
    jumpMethod?: string
  }>
  socialMedia: Array<{
    updateTime: number
    updateBy: string
    configId: number
    mediaType: string
    defaultIcon: string
    hyperlink?: string
    isBuoy: boolean
    remark?: string
    order: number
    createTime?: number
    createBy?: string
  }>
  webTitle: string
  webDescription: string
  webLogo: string
  webIcon: string
  webPageIcon: string
  pwaTitle: string
  pwaShortTitle: string
  pwaIcon: string
  displayDiscount: boolean
}

interface PreloadConfig {
  accessUrl: string
  merchant: PreloadData['merchant']
  homeBanner: PreloadData['homeBanner']
  smallBanner: PreloadData['smallBanner']
  popupImage: PreloadData['popupImage']
  socialMedia: PreloadData['socialMedia']
  webTitle: PreloadData['webTitle']
  webDescription: PreloadData['webDescription']
  webLogo: PreloadData['webLogo']
  blockPreventUrl: string
  WebUpdateVersionInterval: string
  WebUpdateVersionPopUp: string
  jPushConfig: {
    status: string
    baseUrl: string
    appKey: string
  }
  startup: {
    configId: number
    picture: string
    language: string[]
    state: string
    order: number
  }
  gameCategory: Array<{
    id: string
    name: string
    icon: string
    showType: string
    showSidebar: boolean
    count: number
    type: string
  }>
}

class PreloadDataManager {
  private static instance: PreloadDataManager
  private preloadData: PreloadConfig | null = null

  private constructor() {}

  public static getInstance(): PreloadDataManager {
    if (!PreloadDataManager.instance) {
      PreloadDataManager.instance = new PreloadDataManager()
    }
    return PreloadDataManager.instance
  }

  public getPreloadData(): PreloadConfig | null {
    if (!this.preloadData) {
      this.loadPreloadData()
    }
    return this.preloadData
  }

  private loadPreloadData(): void {
    const preloadElement = document.getElementById('preload')
    if (preloadElement && preloadElement.textContent) {
      try {
        // Clean the JSON string by removing control characters and fixing common issues
        let cleanedJson = preloadElement.textContent
          .replace(/[\x00-\x1F\x7F-\x9F]/g, '') // Remove control characters
          .replace(/\t/g, ' ') // Replace tabs with spaces
          .replace(/\n/g, ' ') // Replace newlines with spaces
          .replace(/\r/g, '') // Remove carriage returns
          .replace(/\s+/g, ' ') // Normalize whitespace
          .trim()

        const data = JSON.parse(cleanedJson)
        console.log('data', data)
        this.preloadData = data
        // Remove the preload element after extracting data
        preloadElement.remove()
      } catch (error) {
        console.error('Failed to parse preload data:', error)
        console.error('Raw content:', preloadElement.textContent)
      }
    }
  }

  public getAccessUrl(): string | null {
    return this.preloadData?.accessUrl || null
  }

  public getMerchantConfig() {
    return this.preloadData?.merchant || null
  }

  public getStartupConfig() {
    return this.preloadData?.startup || null
  }

  public getHomeBanner() {
    return this.preloadData?.homeBanner || null
  }

  public getSmallBanner() {
    return this.preloadData?.smallBanner || null
  }

  public getPopupImages() {
    return this.preloadData?.popupImage || null
  }

  public getSocialMedia() {
    return this.preloadData?.socialMedia || null
  }
  public getBlockPreventUrl(): string | null {
    return this.preloadData?.blockPreventUrl || null
  }

  public getWebUpdateVersionInterval(): string | null {
    return this.preloadData?.WebUpdateVersionInterval || null
  }

  public getWebUpdateVersionPopUp(): string | null {
    return this.preloadData?.WebUpdateVersionPopUp || null
  }
}

export default function useLoadPreload() {
  return PreloadDataManager.getInstance()
}

// Export the singleton instance for direct use
export const preloadDataManager = PreloadDataManager.getInstance()
